var paragraph_default = {
  "fontElementMap": "WTSRe",
  "elementSpacing": "-PN3w",
  "text": "thtTy -PN3w",
  "child": "wnQOX"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
